import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UCCFilingData } from "../models/ucc-filing.model";
import { EntityAPIEntityUCCFilingRemote } from "../../infrastructure/entity-api-entity-ucc-filing.remote";

@Injectable({
  providedIn: "root",
})
export class EntityAPIFacade {
    constructor(private readonly remote: EntityAPIEntityUCCFilingRemote) {}

    initialize(entityId: number): Observable<UCCFilingData> {
        return this.remote.initializeUCC1(entityId);
    }

    refresh(entityId: number): Observable<UCCFilingData> {
        return this.remote.refreshUCC1(entityId);
    }

    downloadDocument(fileId: number): void {
        this.remote.downloadDocument(fileId).subscribe();
    }
}